(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6779,4622,3952],{

/***/ 75833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96781);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39712);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65519);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var QuickLinks = function QuickLinks() {
  var _linkStyle, _masterConfig$QuickLi2, _ref2, _ref3;

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .iP)();
  var containerStyle = {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "16px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    margin: "10px 0px",
    overflow: "hidden"
  };
  var headerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: "600",
    marginBottom: "12px",
    lineHeight: "43.21px"
  };
  var iconStyle = {
    // marginRight: "8px",
    fontSize: "20px"
  };
  var scrollableContainer = {
    display: "grid",
    gridTemplateRows: "repeat(1, auto)",
    // Always 2 rows
    gridAutoFlow: "column",
    // Enables horizontal scrolling
    gridAutoColumns: "max-content",
    // Fit content dynamically
    gap: "8px",
    overflowX: "auto",
    // Enables horizontal scrolling
    scrollbarWidth: "none",
    // Hide scrollbar (Firefox)
    msOverflowStyle: "none",
    // Hide scrollbar (IE/Edge)
    whiteSpace: "nowrap" // Ensures proper scrolling

  }; // Hide scrollbar for WebKit browsers (Chrome, Safari)

  var hideScrollbar = {
    "&::-webkit-scrollbar": {
      display: "none"
    }
  };
  var linkStyle = (_linkStyle = {
    display: "block",
    // Ensures width matches content
    padding: "6px 16px",
    borderRadius: "10px",
    border: "1px solid #BBDFE4",
    backgroundColor: "#F9FCFD",
    cursor: "pointer",
    fontSize: size.width > 950 ? "18px" : "14px",
    fontWeight: "400",
    color: "#2D656A",
    textAlign: "center"
  }, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_linkStyle, "fontWeight", "bold"), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_linkStyle, "whiteSpace", "nowrap"), _linkStyle);

  var trendingStyle = _objectSpread(_objectSpread({}, linkStyle), {}, {
    backgroundColor: "#F9FCFD",
    color: "#2D656A",
    border: "none"
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null),
      list = _useState2[0],
      setList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)('hi'),
      lang = _useState3[0],
      setLang = _useState3[1];

  var masterConfig = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_3__/* .MasterConfigContext */ .d);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _masterConfig$QuickLi, _result$result, response, result;

        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("https://api.thelallantop.com" + "/v1/quickLink/detail?accessType=WEB&slug=" + (masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$QuickLi = masterConfig['QuickLinks']) === null || _masterConfig$QuickLi === void 0 ? void 0 : _masterConfig$QuickLi['Slug']) || 0);

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error("Network response was not ok");

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                result = _context.sent;
                console.log(result);
                setList(result === null || result === void 0 ? void 0 : (_result$result = result.result) === null || _result$result === void 0 ? void 0 : _result$result.links);
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                console.error("Fetch error:", _context.t0);
                console.log("Fetch error:", _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);
                setList(null);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var localLanguage = JSON.parse(localStorage.getItem("i18nConfig"));

    if (localLanguage) {
      setLang(localLanguage === null || localLanguage === void 0 ? void 0 : localLanguage.selectedLang);
    }
  }, []);
  return list && masterConfig !== null && masterConfig !== void 0 && (_masterConfig$QuickLi2 = masterConfig['QuickLinks']) !== null && _masterConfig$QuickLi2 !== void 0 && _masterConfig$QuickLi2['Status'] ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    style: {},
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "position-relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
        onSwiper: function onSwiper(swiper) {
          return swiperRef.current = swiper;
        },
        autoplay: false,
        loop: false,
        spaceBetween: 5,
        slidesPerView: "auto" // slidesPerView="auto"
        ,
        onSlideChange: function onSlideChange(swiper) {
          return setActiveIndex(swiper.realIndex);
        },
        className: "mx-5",
        children: list.map(function (link, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
            style: {
              width: 'auto'
            },
            className: "text-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
              href: link === null || link === void 0 ? void 0 : link.url,
              style: list !== null && list !== void 0 && list.isTrending ? trendingStyle : linkStyle,
              className: "w-100",
              children: lang == 'hi' ? link === null || link === void 0 ? void 0 : link.title : link === null || link === void 0 ? void 0 : link.englishTitle
            }, index)
          }, index + 1);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "mt-2 text-end position-absolute",
        style: {
          left: "-2px",
          top: "-22%",
          zIndex: "960"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
          onClick: function onClick() {
            return swiperRef.current.slidePrev();
          },
          className: "btn  ",
          disabled: activeIndex >= 1 ? false : true,
          style: (_ref2 = {
            border: "none",
            transform: "rotate(180deg)",
            borderRadius: "10px"
          }, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref2, "border", "1px solid #BBDFE4"), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref2, "backgroundColor", "#F9FCFD"), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref2, "minWidth", "20px"), _ref2),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("path", {
              d: "M5.19763 11.62L9.00097 7.8167C9.45013 7.36754 9.45013 6.63254 9.00097 6.18337L5.19763 2.38004",
              stroke: "#292D32",
              "stroke-width": "1.25",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "mt-2 text-end position-absolute",
        style: {
          right: "-2px",
          top: "-22%",
          zIndex: "960"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
          onClick: function onClick() {
            return swiperRef.current.slideNext();
          },
          className: "btn  ",
          disabled: activeIndex + 5 !== (list === null || list === void 0 ? void 0 : list.length) - 1 ? false : true,
          style: (_ref3 = {
            border: "none",
            borderRadius: "10px"
          }, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, "border", "1px solid #BBDFE4"), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, "backgroundColor", "#F9FCFD"), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, "minWidth", "20px"), _ref3),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("path", {
              d: "M5.19763 11.62L9.00097 7.8167C9.45013 7.36754 9.45013 6.63254 9.00097 6.18337L5.19763 2.38004",
              stroke: "#292D32",
              "stroke-width": "1.25",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          })
        })
      })]
    })
  }) : "";
};

/* harmony default export */ __webpack_exports__["default"] = (QuickLinks);

/***/ }),

/***/ 65519:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);